import EnumDataSource from "../utils/enum-data-source.util";

export const LEFT_EAR_TYPE = "L";
export const RIGHT_EAR_TYPE = "R";

const earTypes = {
  [LEFT_EAR_TYPE]: "Left",
  [RIGHT_EAR_TYPE]: "Right",
};

export const EAR_TYPES = new EnumDataSource(earTypes);

export const earCodeMap: {
  [key: string]: typeof LEFT_EAR_TYPE | typeof RIGHT_EAR_TYPE;
} = {
  left: LEFT_EAR_TYPE,
  right: RIGHT_EAR_TYPE,
};

const technology = {
  1: "Conventional",
  2: "Digital",
  3: "Programmable",
  4: "Analog",
  5: "Basic",
  6: "Non Programmable",
  7: "OTC",
  8: "CROS",
  999: "Other",
};

export const TECHNOLOGIES = new EnumDataSource(technology);

const hearingAidTypes = {
  1: "BTE",
  2: "miniBTE",
  3: "Power BTE",
  4: "CIC",
  5: "IIC",
  6: "ITC",
  7: "HS",
  8: "ITE",
  9: "MC",
  10: "RIC",
  11: "miniRIC",
  12: "FS",
  13: "RITE",
  14: "Open",
  15: "RIE",
  16: "LP",
  17: "OTE",
  18: "miniRITE",

  999: "Other",
};

export const HEARING_AID_TYPES = new EnumDataSource(hearingAidTypes);

export const RECEIVER_SUBTYPE = 1;
export const EAR_MOLD_SUBTYPE = 2;
export const TUBE_SUBTYPE = 3;
export const DOME_SUBTYPE = 4;
export const BATTERY_SUBTYPE = 5;
export const CHARGER_SUBTYPE = 6;
export const WARRANTY_SUBTYPE = 7;
export const REPAIR_SUBTYPE = 8;
export const REMOTE_SUBTYPE = 9;
export const SHIPPING_HANDLING = 10;
export const EXAM = 11;
export const RESTOCKING = 12;
export const OTHER_SUBTYPE = 999;

export const ADDITIONAL_ACCESSORIES_TYPES = [
  BATTERY_SUBTYPE,
  CHARGER_SUBTYPE,
  REMOTE_SUBTYPE,
  OTHER_SUBTYPE,
];

const accessoriesSubTypes = {
  [RECEIVER_SUBTYPE]: "Receiver",
  [EAR_MOLD_SUBTYPE]: "Earmold",
  [TUBE_SUBTYPE]: "Tube",
  [DOME_SUBTYPE]: "Dome",
  [BATTERY_SUBTYPE]: "Battery",
  [CHARGER_SUBTYPE]: "Charger",
  [REMOTE_SUBTYPE]: "Remote",
  [OTHER_SUBTYPE]: "Other",
};
export const ACCESSORIES_SUB_TYPES = new EnumDataSource(accessoriesSubTypes);

const servicesSubTypes = {
  [WARRANTY_SUBTYPE]: "Warranty",
  [REPAIR_SUBTYPE]: "Repair",
  [OTHER_SUBTYPE]: "Other",
};

export const SERVICES_SUB_TYPES = new EnumDataSource(servicesSubTypes);

const feeSubTypes = {
  [RESTOCKING]: "Restocking",
  [OTHER_SUBTYPE]: "Other",
};

export const FEE_SUB_TYPES = new EnumDataSource(feeSubTypes);

const productSubTypes = {
  [RECEIVER_SUBTYPE]: "Receiver",
  [EAR_MOLD_SUBTYPE]: "Earmold",
  [TUBE_SUBTYPE]: "Tube",
  [DOME_SUBTYPE]: "Dome",
  [BATTERY_SUBTYPE]: "Battery",
  [CHARGER_SUBTYPE]: "Charger",
  [REMOTE_SUBTYPE]: "Remote",
  [WARRANTY_SUBTYPE]: "Warranty",
  [REPAIR_SUBTYPE]: "Repair",
  [SHIPPING_HANDLING]: "Shipping Handling",
  [EXAM]: "Exam",
  [RESTOCKING]: "Restocking",
  [OTHER_SUBTYPE]: "Other",
};

export const PRODUCT_SUB_TYPES = new EnumDataSource(productSubTypes);

const batteryColors = {
  1: "Red",
  2: "Orange",
  3: "Yellow",
  4: "Green",
  5: "Blue",
  6: "Purple",
  7: "Pink",
  8: "White",
  9: "Gray",
  10: "Brown",
  11: "Black",
  12: "Multicolored",
  999: "Other",
};

export const BATTERY_COLORS = new EnumDataSource(batteryColors);

const warrantyFieldTypes = {
  manufacturer_warranty_expiration_date: "MFR Repair Warranty",
  loss_damage_warranty_expiration_date: "Loss and Damage Warranty",
};

export const WARRANTY_FIELD_TYPES = new EnumDataSource(warrantyFieldTypes);

export const QUICK_FILTER_DEFAULT_TYPE: string = "0";
export const QUICK_FILTER_SERVICES_TYPE: string = "1";
export const QUICK_FILTER_HEARING_AIDS_TYPE: string = "2";
export const QUICK_FILTER_ACCESSORIES_TYPE: string = "3";
export const QUICK_FILTER_FEE_TYPE: string = "4";

export const QUICK_FILTER_SUPPLIES_TYPE: string = "5";
export const QUICK_FILTER_INACTIVE: string = "6";

const productsQuickFiltersType = {
  [QUICK_FILTER_DEFAULT_TYPE]: "All",
  [QUICK_FILTER_SERVICES_TYPE]: "Services",
  [QUICK_FILTER_HEARING_AIDS_TYPE]: "Hearing Aids",
  [QUICK_FILTER_ACCESSORIES_TYPE]: "Accessories",
  [QUICK_FILTER_FEE_TYPE]: "Fees",
  [QUICK_FILTER_SUPPLIES_TYPE]: "Supplies",
  [QUICK_FILTER_INACTIVE]: "Inactive",
};

export const QUICK_FILTER_TYPES = new EnumDataSource(productsQuickFiltersType);
export const PATIENT_PRODUCT_LIST_KEY_DEFAULT = "patientProductList";
